import Wrapper from "../../Wrapper";
 const CustomBrokerList = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Custom Broker List </h3>
         </Wrapper>
         </>
     );
 }
 export default CustomBrokerList;